module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/favicon.png","name":"GIAnalyzer for Excel","short_name":"GIAnalyzer","start_url":"https://gianalyzer.com/","display":"browser","background_color":"#FFFFFF","theme_color":"#a11313","description":"Turn your Excel into a powerful financial software","categories":["financial software","business","Excel"],"legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"359d3c9120a1bf9d36b8037d5e2a798a"},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-MQ26XD8VCT"]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
